export const DIGITAL_PRODUCT_API = '/api/dashboard/customer/digital-products'

export const OFFER_API = '/api/dashboard/customer/offer'
